export const NEW_PROJECT_STEPS = {
  step1: "step 1",
  step2: "step 2",
  step3: "step 3",
};
